import { defineNuxtLink } from '#imports';

export default defineNuxtLink({
  componentName: 'AppLink',
  externalRelAttribute: '',
  activeClass: 'is-current',
  exactActiveClass: 'is-exact',
  trailingSlash: 'append',
});
